import {MsgType} from 'matrix-js-sdk';
import {AppVariant, DocumentType} from './common';
import {CompanyUser} from './user';

export type Message = {
  _id: string;
  conversationId: string;
  createdAt: string;
  sentBy: CompanyUser;
  deletedBy: string;
  text: string;
  system?: boolean;
  updatedAt?: string;
};

export type ConversationId = {
  members: string[];
  _id: string;
  createdAt: string;
};

export type EventPosition = 'first' | 'middle' | 'last' | 'single';

export type BoxPosition = 'single' | 'last';

export enum SystemMessageAction {
  RoomJoined = 'system_messages:room_joined',
  RoomLeft = 'system_messages:room_left',
  RoomCreated = 'system_messages:room_created',
  EventCancelled = 'system_messages:event_cancelled',
  EventEdited = 'system_messages:event_edited',
  GroupEdited = 'system_messages:group_edited',
  Invited = 'system_messages:invited',
  MemberInvited = 'system_messages:member_invited',
  Knocked = 'system_messages:knocked',
  NameChange = 'system_messages:namechange',
  InviteRejected = 'system_messages:invite_rejected',
  RoomMetadata = 'system_messages:room_metadata',
  Redacted = 'system_messages:redacted'
}

export type SystemMessageData = 'user' | {nameToShow: string};

export const ACCEPTED_TYPES_IN_MESSAGE_LIST = [
  'm.room.member',
  'm.room.create',
  'm.sj_system_message',
  'm.room.message'
];

export const SYSTEM_MESSAGE_TYPES = [
  'm.room.member',
  'm.room.create',
  'm.sj_system_message'
];

export type MultimediaInfo = {
  h: number;
  w: number;
  index: number;
  mimetype: string;
};

export type AdditionalMultimediaInfo = {
  url: string;
  info: MultimediaInfo;
};

export type MultimediaMessageContent = {
  url: string;
  info: MultimediaInfo;
  body?: string;
  additional: AdditionalMultimediaInfo[];
};

export type ResizedImageInfo = {
  file: File;
  width: number;
  height: number;
};

export const MultimediaEventTypes = [
  'm.image',
  'm.file',
  'm.audio',
  'm.location',
  'm.video'
];

export type Multimedia = 'image' | 'video';

export type MultimediaFileTypes = {
  video: File[];
  image: ResizedImageInfo[];
};

export type MultimediaUploadInfo = {
  type: Multimedia;
  file: File;
};

export type MultimediaDownloadInfo = {
  type: Multimedia;
  url: string;
  mimeType: string;
};

export type MultimediaFileInfo = {
  type: Multimedia;
  file: File | ResizedImageInfo;
  previewUrl: string;
};

export type MatrixCredentials = {
  accessToken: string;
  userId: string;
  deviceId: string;
};

export type RoomMetadata = {
  topic: string;
  appVariant: AppVariant;
  documentType: DocumentType;
};

export enum SjMatrixMessageType {
  Metadata = 'sj:room-metadata',
  SystemMessage = 'm.sj_system_message'
}

export enum MatrixMembership {
  JOIN = 'join',
  LEAVE = 'leave',
  KNOCK = 'knock',
  INVITE = 'invite'
}

export interface SystemMessageEventContent {
  body: string;
  msgtype: MsgType.Text;
  data: SystemMessageData;
}
